<h2 mat-dialog-title>{{ 'supportTickets.dialogTitle' | translate }}</h2>

<mat-dialog-content class="dialog-body">
  <p class="hint">
    {{ 'supportTickets.newRequestHint' | translate }}
  </p>
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ 'supportTickets.subject' | translate }}</mat-label>
    <input matInput name="subject" [(ngModel)]="subject" [disabled]="submitting" />
  </mat-form-field>
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ 'supportTickets.details' | translate }}</mat-label>
    <textarea
      matInput
      name="description"
      rows="6"
      [(ngModel)]="description"
      [disabled]="submitting"
    ></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()" [disabled]="submitting">
    {{ 'supportTickets.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="submitting">
    <mat-spinner *ngIf="submitting" diameter="20" class="btn-spinner"></mat-spinner>
    <span *ngIf="!submitting">{{ 'supportTickets.submit' | translate }}</span>
  </button>
</mat-dialog-actions>
